import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { 
    FaGavel, 
    FaFileContract, 
    FaExclamationTriangle, 
    FaCheckCircle,
    FaTimesCircle,
    FaEnvelope,
    FaPhone,
    FaGlobe
} from 'react-icons/fa';
import './About.css';
import BannerWithBreadcrumb from '../components/BannerWithBreadcrumb';

const Terms = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div className="about-page">
            <BannerWithBreadcrumb
                title="Terms of Service"
                breadcrumbItems={[
                    { label: 'Home', link: '/' },
                    { label: 'Terms of Service' }
                ]}
            />
            {/* Terms Content */}
            <section className="content-section">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.8, delay: 0.2 }}
                            >
                                <Card className="privacy-card">
                                    <Card.Body>
                                        <h2>1. Acceptance of Terms</h2>
                                        <p>By accessing and using Business Directory services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>

                                        <h2>2. Description of Service</h2>
                                        <p>Business Directory provides an online platform that allows users to:</p>
                                        <ul>
                                            <li>Browse and search for local businesses</li>
                                            <li>Add and manage business listings</li>
                                            <li>Leave reviews and ratings</li>
                                            <li>Contact businesses directly</li>
                                            <li>Access business information and details</li>
                                        </ul>

                                        <h2>3. User Accounts</h2>
                                        <h3>Account Creation</h3>
                                        <p>To access certain features, you must create an account. You agree to:</p>
                                        <ul>
                                            <li>Provide accurate and complete information</li>
                                            <li>Maintain the security of your account credentials</li>
                                            <li>Notify us immediately of any unauthorized use</li>
                                            <li>Accept responsibility for all activities under your account</li>
                                        </ul>

                                        <h3>Account Termination</h3>
                                        <p>We reserve the right to terminate accounts that:</p>
                                        <ul>
                                            <li>Violate these terms of service</li>
                                            <li>Engage in fraudulent or illegal activities</li>
                                            <li>Provide false or misleading information</li>
                                            <li>Are inactive for extended periods</li>
                                        </ul>

                                        <h2>4. Business Listings</h2>
                                        <h3>Adding Business Information</h3>
                                        <p>When adding business listings, you agree to:</p>
                                        <ul>
                                            <li>Provide accurate and truthful information</li>
                                            <li>Have the authority to represent the business</li>
                                            <li>Maintain up-to-date business information</li>
                                            <li>Comply with all applicable laws and regulations</li>
                                        </ul>

                                        <h3>Content Guidelines</h3>
                                        <p>Business listings must not contain:</p>
                                        <ul>
                                            <li>False or misleading information</li>
                                            <li>Offensive or inappropriate content</li>
                                            <li>Spam or promotional material</li>
                                            <li>Content that violates intellectual property rights</li>
                                        </ul>

                                        <h2>5. User Conduct</h2>
                                        <p>You agree not to:</p>
                                        <ul>
                                            <li>Use the service for any unlawful purpose</li>
                                            <li>Attempt to gain unauthorized access to our systems</li>
                                            <li>Interfere with or disrupt the service</li>
                                            <li>Harass, abuse, or harm other users</li>
                                            <li>Post false or misleading reviews</li>
                                            <li>Use automated systems to access the service</li>
                                        </ul>

                                        <h2>6. Intellectual Property</h2>
                                        <h3>Our Rights</h3>
                                        <p>Business Directory and its content are protected by copyright, trademark, and other intellectual property laws. You may not:</p>
                                        <ul>
                                            <li>Copy, reproduce, or distribute our content</li>
                                            <li>Create derivative works</li>
                                            <li>Use our trademarks without permission</li>
                                            <li>Reverse engineer our software</li>
                                        </ul>

                                        <h3>Your Rights</h3>
                                        <p>You retain ownership of content you submit, but grant us a license to use, display, and distribute it in connection with our services.</p>

                                        <h2>7. Privacy and Data Protection</h2>
                                        <p>Your privacy is important to us. Our collection and use of personal information is governed by our Privacy Policy, which is incorporated into these terms by reference.</p>

                                        <h2>8. Disclaimers and Limitations</h2>
                                        <h3>Service Availability</h3>
                                        <p>We strive to provide reliable service but cannot guarantee:</p>
                                        <ul>
                                            <li>Uninterrupted access to our services</li>
                                            <li>Error-free operation</li>
                                            <li>Compatibility with all devices or browsers</li>
                                            <li>Immediate resolution of technical issues</li>
                                        </ul>

                                        <h3>Business Information</h3>
                                        <p>We do not verify all business information and are not responsible for:</p>
                                        <ul>
                                            <li>Accuracy of business listings</li>
                                            <li>Quality of products or services</li>
                                            <li>Business practices or policies</li>
                                            <li>Disputes between users and businesses</li>
                                        </ul>

                                        <h2>9. Limitation of Liability</h2>
                                        <p>To the maximum extent permitted by law, Business Directory shall not be liable for:</p>
                                        <ul>
                                            <li>Indirect, incidental, or consequential damages</li>
                                            <li>Loss of profits, data, or business opportunities</li>
                                            <li>Damages resulting from third-party actions</li>
                                            <li>Issues beyond our reasonable control</li>
                                        </ul>

                                        <h2>10. Indemnification</h2>
                                        <p>You agree to indemnify and hold harmless Business Directory from any claims, damages, or expenses arising from:</p>
                                        <ul>
                                            <li>Your use of our services</li>
                                            <li>Your violation of these terms</li>
                                            <li>Your content or business listings</li>
                                            <li>Your interactions with other users</li>
                                        </ul>

                                        <h2>11. Modifications to Terms</h2>
                                        <p>We may modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of our services constitutes acceptance of the modified terms.</p>

                                        <h2>12. Governing Law</h2>
                                        <p>These terms are governed by the laws of [Your Jurisdiction]. Any disputes shall be resolved in the courts of [Your Jurisdiction].</p>

                                        <h2>13. Severability</h2>
                                        <p>If any provision of these terms is found to be unenforceable, the remaining provisions will continue in full force and effect.</p>

                                        <h2>14. Entire Agreement</h2>
                                        <p>These terms, together with our Privacy Policy, constitute the entire agreement between you and Business Directory regarding our services.</p>

                                        <h2>15. Contact Information</h2>
                                        <p>If you have questions about these Terms of Service, please contact us:</p>
                                        <div className="contact-info">
                                            <div className="contact-item">
                                                <FaEnvelope className="contact-icon" />
                                                <div>
                                                    <h6>Email</h6>
                                                    <p>legal@businessdirectory.com</p>
                                                </div>
                                            </div>
                                            <div className="contact-item">
                                                <FaPhone className="contact-icon" />
                                                <div>
                                                    <h6>Phone</h6>
                                                    <p>+1 (555) 123-4567</p>
                                                </div>
                                            </div>
                                            <div className="contact-item">
                                                <FaGlobe className="contact-icon" />
                                                <div>
                                                    <h6>Address</h6>
                                                    <p>123 Business Ave, Suite 100<br />City, State 12345</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default Terms; 